import { Swiper, Navigation, Pagination, Autoplay } from "swiper/dist/js/swiper.esm.js";

Swiper.use([Navigation, Pagination, Autoplay]);

export default () => {
    var swiper = new Swiper('.gallery-modal-slider', {
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
    });

    // componente de banner padrão
    let bannerDefault = new Swiper(".banner__default", {
        watchOverflow: true,
        navigation: {
            nextEl: '.banner-button-next',
            prevEl: '.banner-button-prev',
        },
        pagination: {
            el: ".banner-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let bannerHome = new Swiper(".banner__home", {
        watchOverflow: true,
        navigation: {
            nextEl: '.home-button-next',
            prevEl: '.home-button-prev',
        },
        pagination: {
            el: ".home-pagination",
            type: "bullets",
            clickable: true,
        },
    });

    let swiperPartners = new Swiper(".swiper__partners", {
        watchOverflow: true,
        slidesPerView: 4,
        spaceBetween: 32,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
        },
        breakpoints: {
            600: {
                slidesPerView: 2,
                spaceBetween: 32,
            },
            900: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 32,
            },
        },
        navigation: {
            nextEl: ".partners-button-next",
            prevEl: ".partners-button-prev",
        },
    });

    let gallerySlider = new Swiper(".gallery__slider", {
        watchOverflow: true,
        autoplay: {
            delay: 5000,
        },
        pagination: {
            el: ".gallery-pagination",
            type: "bullets",
            clickable: true,
        },
        navigation: {
            nextEl: '.gallery-button-next',
            prevEl: '.gallery-button-prev',
        },
    });
};